/**
 * El token del link para el vendedor viaja en la URL (`/conectar/<token>`) y, con él, cualquiera conecta
 * una cuenta de Mercado Libre a ese cliente durante 7 días. Sentry guarda la URL de cada error (y las
 * migas de navegación), así que esto lo reemplaza por `[token]` en todo el evento antes de mandarlo.
 * Se enchufa en el `beforeSend` de Sentry (`src/utils/sentryBeforeSend.js`).
 *
 * La API pública también lo lleva en la URL (`public/connection-links/<token>/` y `…/auth-url/`), y esa
 * URL queda en las migas de fetch/xhr y viaja con cualquier error posterior de la página. El id del link
 * en la URL de anular (`agency/connection-links/<id>/revoke/`) también se tapa: no es secreto, pero por la
 * forma no se distingue del token.
 */
const LINK_TOKEN_IN_URL = /\/conectar\/[^/?#\s"'<>]+/g;
const REDACTED = '/conectar/[token]';
const API_TOKEN_IN_URL = /connection-links\/[^/?#\s"'<>]+/g;
const API_REDACTED = 'connection-links/[token]';
const MAX_DEPTH = 12;

export function scrubLinkTokenInText(text) {
    return text.replace(LINK_TOKEN_IN_URL, REDACTED).replace(API_TOKEN_IN_URL, API_REDACTED);
}

/** Recorre el evento (pedido, migas, excepciones, extras) y limpia cada texto. Lo modifica y lo devuelve. */
export function scrubLinkToken(value, depth = 0) {
    if (typeof value === 'string') return scrubLinkTokenInText(value);
    if (!value || typeof value !== 'object' || depth > MAX_DEPTH) return value;
    if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i += 1) value[i] = scrubLinkToken(value[i], depth + 1);
        return value;
    }
    for (const key of Object.keys(value)) value[key] = scrubLinkToken(value[key], depth + 1);
    return value;
}
